import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'

function EditarGrupo(props) {
	const { grupo, guardar, setQueMostrar } = props
	const [datos, setDatos] = useState({})

	useEffect(() => {
		setDatos({
			id: grupo.id,
			nombre: grupo.nombre,
			orden: grupo.orden
		})
	}, [grupo])

	const handleClose = () => {
		setQueMostrar('')
		setDatos({})
	}

	const handleProcesar = (e) => {
		e.preventDefault()
		guardar(datos)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Editar grupo de galería" />
			<Offcanvas.Body>
				<h1>Datos del grupo</h1>
				{datos.id && (
					<Row>
						<Col sm={12} md={6}>
							<Form onSubmit={handleProcesar} className="ms-4">
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="grupo-nombre">
											<FormLabel>Nombre</FormLabel>
											<Form.Control
												value={datos.nombre}
												type="text"
												onChange={(e) => handleChange(e.target.value, 'nombre')}
												required
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<Form.Group className="mb-3 col-md-3" controlId="grupo-orden">
											<FormLabel>Orden</FormLabel>
											<Form.Control
												value={datos.orden}
												type="number"
												onChange={(e) => handleChange(e.target.value, 'orden')}
												required
											/>
										</Form.Group>
									</Col>
								</Row>
							</Form>
						</Col>
					</Row>
				)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarGrupo